import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { cdnIconVariants, cdnIconVariantsFields } from "./CdnIcon.variants.js";
const CdnIcon_CdnIcon = /*#__PURE__*/ forwardRef(function({ className, iconName, title, 'data-testid': dataTestId, ...props }, ref) {
    const classes = cn(cdnIconVariants(props), 'notranslate', className);
    const domProps = cleanProps(props, cdnIconVariantsFields);
    return iconName ? /*#__PURE__*/ jsx("span", {
        ref: ref,
        ...domProps,
        className: classes,
        title: title,
        "data-testid": dataTestId,
        children: iconName
    }) : /*#__PURE__*/ jsx("span", {
        ref: ref,
        ...domProps,
        "data-testid": "empty-icon",
        className: classes,
        title: title
    });
});
export { CdnIcon_CdnIcon as CdnIcon };
